import {
    DELETE_GROUP_ANNOUNCEMENT_SUCCESS,
    DELETE_GROUP_ANNOUNCEMENT_FAILED,
    DELETE_GROUP_POST,
    DELETE_GROUP_POST_FAILED,
    DELETE_GROUP_POST_SUCCESS,
    FETCH_GROUP,
    FETCH_GROUP_FAIL,
    FETCH_GROUP_POSTS,
    FETCH_GROUP_POSTS_FAILED,
    FETCH_GROUP_POSTS_SUCCESS,
    FETCH_GROUP_POST_START,
    FETCH_GROUP_POST_SUCCESS,
    FETCH_GROUP_POST_FAILED,
    FETCH_GROUP_COMMENTS,
    FETCH_GROUP_COMMENTS_FAILED,
    FETCH_GROUP_COMMENTS_SUCCESS,
    FETCH_GROUP_SUCCESS,
    SAVE_GROUP_ANNOUNCEMENT,
    SAVE_GROUP_ANNOUNCEMENT_FAILED,
    SAVE_GROUP_ANNOUNCEMENT_SUCCESS,
    RESET_GROUP_PAGE,
    SAVE_GROUP_POST,
    SAVE_GROUP_COMMENT,
    SAVE_GROUP_COMMENT_FAILED,
    SAVE_GROUP_COMMENT_SUCCESS,
    EDIT_GROUP_COMMENT_START,
    EDIT_GROUP_COMMENT_SUCCESS,
    EDIT_GROUP_COMMENT_FAILED,
    SAVE_GROUP_POST_FAILED,
    SAVE_GROUP_POST_SUCCESS,
    SET_GROUP_PAGE_TAB,
    SET_GROUP_PAGE_FEED_TAB_START,
    DELETE_GROUP_COMMENT,
    DELETE_GROUP_COMMENT_FAILED,
    DELETE_GROUP_COMMENT_SUCCESS,
    CLOSE_DELETE_CONFIRM_DIALOG,
    OPEN_DELETE_CONFIRM_DIALOG,
    FETCH_GROUP_CONVERSATION_LIKERS,
    UPDATE_GROUP_CONVERSATION_LIKE_START,
    FETCH_GROUP_COMMENT_LIKERS,
    UPDATE_GROUP_COMMENT_LIKE_START,
    FETCH_GROUP_CONVERSATION_LIKERS_DONE,
    UPDATE_GROUP_CONVERSATION_LIKE_DONE,
    FETCH_GROUP_COMMENT_LIKERS_DONE,
    UPDATE_GROUP_COMMENT_LIKE_DONE,
    FETCH_GROUP_ALL_FEEDS_START,
    FETCH_GROUP_ALL_FEEDS_SUCCESS,
    FETCH_GROUP_ALL_FEEDS_FAILED,
    FETCH_GROUP_ACTIVITY_FEEDS,
    FETCH_GROUP_ACTIVITY_FEEDS_SUCCESS,
    FETCH_GROUP_ACTIVITY_FEEDS_FAILED,
    FETCH_GROUP_ACTIVITY_FEED_START,
    FETCH_GROUP_ACTIVITY_FEED_SUCCESS,
    FETCH_GROUP_ACTIVITY_FEED_FAILED,
    UPDATE_GROUP_MEMBERS,
    SORT_GROUP_MEMBERS,
    UPDATE_GROUP_INVITES,
    UPDATE_GROUP_USER_CONNECTIONS,
    UPDATE_GROUP_USER_CONNECTION_DONE,
    GROUP_PAGE_CANCEL_INVITE_USER_DONE,
    GROUP_PAGE_INVITE_USER_DONE,
    UPDATE_GROUP_MEMBER_REQUEST,
    GROUP_PAGE_JOIN_GROUP_SUCCESS,
    GROUP_PAGE_ACCEPT_INVITATION_SUCCESS,
    REMOVE_GROUP_MEMBER_SUCCESS,
    REMOVE_GROUP_MEMBER_FAILED,
    UPDATE_GROUP_MEMBER_ROLE_SUCCESS,
    UPDATE_GROUP_MEMBER_ROLE_FAILED,
    TRANSFER_GROUP_OWNERSHIP_SUCCESS,
    TRANSFER_GROUP_OWNERSHIP_FAILED,
    FETCH_GROUP_CHALLENGES_START,
    FETCH_GROUP_CHALLENGES_SUCCESS,
    FETCH_GROUP_CHALLENGES_FAILED,
    UPDATE_GROUP_CHALLENGE_START,
    UPDATE_GROUP_CHALLENGE_SUCCESS,
    UPDATE_GROUP_CHALLENGE_FAILED,
    DELETE_GROUP_CHALLENGE_START,
    DELETE_GROUP_CHALLENGE_SUCCESS,
    DELETE_GROUP_CHALLENGE_FAILED,
    UPDATE_GROUP_CHALLENGE_UUID,
    UPDATE_GROUP_CHALLENGE_VIEW,
    FETCH_GROUP_CHALLENGE_LEADERBOARD_START,
    FETCH_GROUP_CHALLENGE_LEADERBOARD_SUCCESS,
    FETCH_GROUP_CHALLENGE_LEADERBOARD_FAILED,
    RESET_GROUP_SHOW_ERROR_ALERT,
    RESET_GROUP_FEED_ANIMATE_STATE,
    UPLOAD_POST_IMAGE_START,
    UPLOAD_POST_IMAGE_SUCCESS,
    UPLOAD_POST_IMAGE_FAILED,
    REMOVE_POST_IMAGE,
    REMOVE_POST_IMAGES,
    UPDATE_POST_IMAGES,
    UPDATE_POST_IMAGES_LIMIT_ERROR,
    RESET_POST_IMAGES_UPLOAD_RETRY_HINT,
    RESET_GROUP_POST_ERROR,
    RESET_GROUP_ANNOUNCEMENT_ERROR,
    INITIALIZE_GROUP_SINGLE_PAGE_SUCCESS,
    INITIALIZE_GROUP_SINGLE_PAGE_FAILED,
    RESET_GROUP_COMMENT_FOCUS,
    UPDATE_GROUP_PAGE_SHOW_ERROR_ALERT,
    REMOVE_IMAGE_FROM_GROUP_POST_START,
    REMOVE_GROUP_PROFILE_IMAGE,
    GROUP_PAGE_UPDATE_GROUP_SETTING,
    GROUP_PAGE_RESET_SHOW_CHANGES_SAVED,
    DELETE_POST_IMAGE_SUCCESS,
    DELETE_POST_IMAGE_FAILED,
    REMOVE_IMAGE_FROM_GROUP_ACTIVITY_FEED
} from '../../actions/ActionTypes';

import { RESOURCE_TYPE, FEED_TAB_TYPE, GROUP_ROLE, ALL_FEED_TYPE, TAB_IDS } from 'utils/groups/GroupsUtil';
import { isStatusAccepted } from 'utils/connectionStatus/connectionStatusUtils';
import { omitInState } from './groupPageHelper';

export const challengeViewType = {
    all: 'All',
    detail: 'Detail'
};

const INITIAL_STATE = {
    viewerSocialProfile: null,
    viewerUserPreferences: null,
    viewerUserBiometrics: null,
    fetching: true,
    group: null,
    isGroupPrivate: false,
    isGroupDeleted: false,
    /** group members */
    groupMembers: [],
    groupViewerMember: [],
    groupConnectionMembers: [],
    groupNonConnectionMembers: [],
    groupUserConnections: [],
    groupAnnouncement: null,
    groupMemberRequest: null,
    groupInvites: [],
    groupRejectedInvites: [],
    groupInvitation: null,
    viewerIsAdmin: false,
    tab: null,
    feedTab: FEED_TAB_TYPE.ALL,
    showViewPost: false,
    showViewAnnouncement: false,
    groupAnnouncementRenderKey: null,
    postingGroupAnnouncement: false,
    postingGroupAnnouncementSuccess: false,
    postingGroupAnnouncementError: false,
    postingGroupPost: false,
    postingGroupPostError: false,
    postingGroupPostSuccess: false,
    /** all feeds */
    allFeeds: {
        fetching: false,
        success: false,
        error: false,
        list: [],
        cursor: null,
        daysLimit: null
    },
    /** activity feeds */
    activityFeed: {
        fetching: false,
        success: false,
        error: false,
        list: [],
        cursor: null,
        daysLimit: null
    },
    /** posts */
    groupPosts: {
        fetching: false,
        success: false,
        error: false,
        list: [],
        cursor: null
    },
    /** post images */
    groupPostImages: [],
    groupPostImageEditMode: false,
    groupPostImageUploading: false,
    groupPostHasValidImage: false,
    groupPostHasFailedImage: false,
    groupPostImageLastIndex: null,
    /** commets & likes */
    comments: {},
    highlightedComments: {},
    uiPostState: {},
    uiCommentsState: {},
    uiAddCommentState: {},
    uiEditCommentState: {},
    uiCommentState: {},
    conversationLikers: {},
    commentLikers: {},
    /** delete dialog */
    deleteDialog: {
        open: false,
        deleteType: null,
        postUuid: null,
        course: null
    },
    challenges: {
        view: challengeViewType.all,
        fetching: false,
        fetchSuccess: false,
        fetchError: false,
        nonCompleted: [],
        userJoined: [],
        updateSuccess: false,
        updateError: false,
        deleteSuccess: false,
        deleteError: false,
        prevUuid: null,
        currentUuid: null,
        nextUuid: null,
        leaderboard: null,
        leaderboardFetching: false,
        leaderboardFetchSuccess: false,
        leaderboardFetchError: false
    },
    showCommentError: false,
    showGeneralErrorAlert: false,
    showPhotoLimitError: false,
    showImageUploadRetryHint: false,
    initializeSinglePageDone: false,
    initializeSinglePageError: false,
    singlePageErrorStatus: null,
    focusCommentUuid: null,
    showGroupPageErrorAlert: false,
    showChangesSaved: false,
    inviteLimitDays: null
};

/** selector */
export const selectViewerSocialProfile = (state) => state.groupPage.viewerSocialProfile;

export const selectViewerUserPreferences = (state) => state.groupPage.viewerUserPreferences;

export const selectViewerUserBiometrics = (state) => state.groupPage.viewerUserBiometrics;

export const selectViewerIsAuthenticated = (state) =>
    !!(state.groupPage.viewerSocialProfile && state.groupPage.viewerSocialProfile.profileId);

export const selectGroupPageFetching = (state) => state.groupPage.fetching;

export const selectIsGroupPrivate = (state) => state.groupPage.isGroupPrivate;
export const selectIsGroupDeleted = (state) => state.groupPage.isGroupDeleted;

export const selectGroup = (state) => state.groupPage.group;
export const selectGroupId = (state) => state.groupPage.group.id;
export const selectGroupOwnerId = (state) => state.groupPage.group.ownerId;
export const selectGroupName = (state) => state.groupPage.group.groupName;
export const selectGroupActivityFeedTypes = (state) => state.groupPage.group.activityFeedTypes;

export const selectGroupMembers = (state) => state.groupPage.groupMembers;

export const selectGroupUserConnections = (state) => state.groupPage.groupUserConnections;

export const selectGroupInvites = (state) => state.groupPage.groupInvites;
export const selectGroupRejectedInvites = (state) => state.groupPage.groupRejectedInvites;

export const selectGroupMemberRequest = (state) => state.groupPage.groupMemberRequest;

export const selectGroupInvitation = (state) => state.groupPage.groupInvitation;

export const selectGroupAnnouncement = (state) => state.groupPage.groupAnnouncement;

export const selectViewerIsAdmin = (state) => {
    const { group } = state.groupPage;

    if (!group) return false;
    return [GROUP_ROLE.OWNER, GROUP_ROLE.ADMIN].includes(group.membershipStatus);
};

export const selectViewerIsOwner = (state) => {
    const { group } = state.groupPage;

    if (!group) return false;
    return group.membershipStatus === GROUP_ROLE.OWNER;
};

// return true if viewer has any group role
export const selectViewerIsMember = (state) => {
    const { group } = state.groupPage;

    if (!group) return false;
    return [GROUP_ROLE.OWNER, GROUP_ROLE.ADMIN, GROUP_ROLE.MEMBER].includes(group.membershipStatus);
};

export const selectTab = (state) => state.groupPage.tab;

export const selectPostingGroupAnnouncement = (state) => state.groupPage.postingGroupAnnouncement;
export const selectPostingGroupAnnouncementSuccess = (state) => state.groupPage.postingGroupAnnouncementSuccess;
export const selectPostingGroupAnnouncementError = (state) => state.groupPage.postingGroupAnnouncementError;
export const selectPostingGroupPost = (state) => state.groupPage.postingGroupPost;
export const selectPostingGroupPostSuccess = (state) => state.groupPage.postingGroupPostSuccess;
export const selectPostingGroupPostError = (state) => state.groupPage.postingGroupPostError;

export const selectShowViewPost = (state) => state.groupPage.showViewPost;
export const selectShowViewAnnouncement = (state) => state.groupPage.showViewAnnouncement;

/** Posts selectors */
export const selectGroupPosts = (state) => state.groupPage.groupPosts;
export const selectGroupPostsCursor = (state) => state.groupPage.groupPosts.cursor;
export const selectFetchingGroupPosts = (state) => state.groupPage.groupPosts.fetching;

export const selectGroupPost = (state, { postUuid }) => {
    const selectFromAllList = state.groupPage.feedTab === FEED_TAB_TYPE.ALL;
    const post = selectFromAllList
        ? state.groupPage.allFeeds.list.find((feed) => feed.data.uuid === postUuid)
        : state.groupPage.groupPosts.list.find((post) => post.uuid === postUuid);

    return (selectFromAllList ? post && post.data : post) || {};
};

export const selectInitializeSinglePageError = (state) => state.groupPage.initializeSinglePageError;
export const selectInitializeSinglePageDone = (state) => state.groupPage.initializeSinglePageDone;
export const selectSinglePageErrorStatus = (state) => state.groupPage.singlePageErrorStatus;

export const selectGroupFocusCommentUuid = (state) => {
    return state.groupPage.focusCommentUuid;
};

export const selectUiCommentsState = (state, { resourceType, resourceId }) => {
    const resourceKey = `${resourceType}/${resourceId}`;
    return state.groupPage.uiCommentsState[resourceKey];
};

export const selectGroupCommentsFetching = (state, { resourceType, resourceId }) => {
    const commentSectionState = selectUiCommentsState(state, { resourceType, resourceId });
    if (!commentSectionState) {
        return false;
    }
    return commentSectionState.fetching;
};

export const selectGroupCommentsInitialFetchDone = (state, { resourceType, resourceId }) => {
    const commentSectionState = selectUiCommentsState(state, { resourceType, resourceId });
    if (!commentSectionState) {
        return false;
    }
    return commentSectionState.initialFetchDone;
};

export const selectGroupCommentsError = (state, { resourceType, resourceId }) => {
    const commentSectionState = selectUiCommentsState(state, { resourceType, resourceId });
    if (!commentSectionState) {
        return false;
    }
    return commentSectionState.error;
};

export const selectGroupCommentsHasMore = (state, { resourceType, resourceId }) => {
    const commentSectionState = selectUiCommentsState(state, { resourceType, resourceId });
    if (!commentSectionState) {
        return false;
    }
    return commentSectionState.hasMore;
};

export const selectGroupCommentsNextCursor = (state, { resourceType, resourceId }) => {
    const comments = selectGroupComments(state, { resourceType, resourceId });
    return comments.length + 1;
};

export const selectGroupComments = (state, { resourceType, resourceId }) => {
    const resourceKey = `${resourceType}/${resourceId}`;
    return state.groupPage.comments[resourceKey] || [];
};

export const selectGroupHighlightedComments = (state, { resourceType, resourceId }) => {
    const resourceKey = `${resourceType}/${resourceId}`;
    return state.groupPage.highlightedComments[resourceKey] || [];
};

export const selectGroupAddCommentState = (state, { resourceType, resourceId }) => {
    const resourceKey = `${resourceType}/${resourceId}`;
    return state.groupPage.uiAddCommentState[resourceKey] || {};
};

export const selectGroupEditCommentState = (state, { conversationCommentUuid }) => {
    return state.groupPage.uiEditCommentState[conversationCommentUuid] || {};
};

export const selectGroupPostDeleting = (state, { postUuid }) => {
    const currentState = state.groupPage.uiPostState[postUuid];
    if (!currentState) {
        return false;
    }
    return currentState.deleting;
};

export const selectGroupCommentLikeDeleting = (state, { resourceType, resourceId, comment }) => {
    const { conversationUuid, conversationCommentUuid } = comment;
    const resourceKey = `${resourceType}/${resourceId}`;
    const commentKey = `${conversationUuid}/${conversationCommentUuid}`;
    const currentState = state.groupPage.uiCommentState[resourceKey];
    if (!currentState || !currentState[commentKey]) {
        return false;
    }
    return currentState[commentKey].deleting;
};

export const selectDeleteDialogState = (state) => state.groupPage.deleteDialog;

export const selectDeleteType = (state) => state.groupPage.deleteDialog.deleteType;

export const selectDeleteDialogOpen = (state) => state.groupPage.deleteDialog.open;

export const selectDeleteCourse = (state) => state.groupPage.deleteDialog.course;

export const selectGroupConversationLikeUpdating = (state, { resourceType, resourceId }) => {
    const resourceKey = `${resourceType}/${resourceId}`;
    const subState = state.groupPage.conversationLikers[resourceKey];
    if (!subState) {
        return null;
    }
    return subState.updating || false;
};

export const selectGroupCommentLikers = (state, { resourceType, resourceId, conversationCommentUuid }) => {
    const resourceKey = `${resourceType}/${resourceId}`;
    const subState = state.groupPage.commentLikers[resourceKey];
    if (!subState || !subState[conversationCommentUuid]) {
        return null;
    }
    return subState[conversationCommentUuid].likers || null;
};

export const selectGroupCommentLikersFetching = (state, { resourceType, resourceId, conversationCommentUuid }) => {
    const resourceKey = `${resourceType}/${resourceId}`;
    const subState = state.groupPage.commentLikers[resourceKey];
    if (!subState || !subState[conversationCommentUuid]) {
        return false;
    }
    return subState[conversationCommentUuid].fetching || false;
};

export const selectGroupCommentLikeUpdaing = (state, { resourceType, resourceId, conversationCommentUuid }) => {
    const resourceKey = `${resourceType}/${resourceId}`;
    const subState = state.groupPage.commentLikers[resourceKey];
    if (!subState || !subState[conversationCommentUuid]) {
        return false;
    }
    return subState[conversationCommentUuid].updating || false;
};

export const selectGroupCommentLikersSuccess = (state, { resourceType, resourceId, conversationCommentUuid }) => {
    const resourceKey = `${resourceType}/${resourceId}`;
    const subState = state.groupPage.commentLikers[resourceKey];
    if (!subState || !subState[conversationCommentUuid]) {
        return false;
    }
    return subState[conversationCommentUuid].success || false;
};

export const selectGroupPageActivityFeedState = (state) => state.groupPage.activityFeed;

export const selectGroupActivityFeeds = (state) => {
    const activityFeed = selectGroupPageActivityFeedState(state);
    return activityFeed.list || [];
};

export const selectFetchingGroupActivityFeeds = (state) => {
    const activityFeed = selectGroupPageActivityFeedState(state);
    return activityFeed.fetching;
};

export const selectHasMoreGroupActivityFeeds = (state) => {
    const activityFeed = selectGroupPageActivityFeedState(state);
    return activityFeed.hasMore;
};

export const selectGroupActivityFeedsCursor = (state) => {
    const activityFeed = selectGroupPageActivityFeedState(state);
    return activityFeed.cursor;
};

export const selectGroupActivityFeedsDaysLimit = (state) => {
    const activityFeed = selectGroupPageActivityFeedState(state);
    return activityFeed.daysLimit;
};

export const selectGroupAllFeedsList = (state) => {
    return state.groupPage.allFeeds.list;
};

export const selectGroupAllFeedsCursor = (state) => {
    return state.groupPage.allFeeds.cursor;
};

export const selectGroupChallengesFetching = (state) => state.groupPage.challenges.fetching;
export const selectGroupChallengesFetchSuccess = (state) => state.groupPage.challenges.fetchSuccess;
export const selectGroupChallengesNonCompleted = (state) => state.groupPage.challenges.nonCompleted;
export const selectGroupChallengesUserJoined = (state) => state.groupPage.challenges.userJoined;
export const selectGroupChallenge = (state, uuid) =>
    state.groupPage.challenges.nonCompleted.find((challenge) => challenge.uuid === uuid) ||
    state.groupPage.challenges.userJoined.find((challenge) => challenge.uuid === uuid);
export const selectGroupCurrentChallenge = (state) => {
    const uuid = state.groupPage.challenges.currentUuid;
    return (
        state.groupPage.challenges.nonCompleted.find((challenge) => challenge.uuid === uuid) ||
        state.groupPage.challenges.userJoined.find((challenge) => challenge.uuid === uuid)
    );
};
export const selectGroupChallengesCurrentUuid = (state) => state.groupPage.challenges.currentUuid;

export const selectShowGroupPageErrorAlert = (state) => state.groupPage.showGroupPageErrorAlert;

/** action handlers */
const fetchGroup = (_, action) => {
    return {
        ...INITIAL_STATE,
        viewerSocialProfile: action.viewerSocialProfile,
        viewerUserPreferences: action.viewerUserPreferences,
        viewerUserBiometrics: action.viewerUserBiometrics
    };
};

const fetchGroupSuccess = (state, action) => {
    return {
        ...state,
        fetching: false,
        group: action.group,
        groupMembers: action.groupMembers,
        groupAnnouncement: action.groupAnnouncement,
        groupAnnouncementRenderKey: Date.now(),
        groupUserConnections: action.groupUserConnections,
        groupMemberRequest: action.groupMemberRequest,
        groupInvitation: action.groupInvitation
    };
};

const fetchGroupFail = (state, { isGroupPrivate, isGroupDeleted }) => {
    return {
        ...state,
        fetching: false,
        isGroupPrivate,
        isGroupDeleted
    };
};

const setGroupPageTab = (state, action) => {
    return {
        ...state,
        tab: action.tab
    };
};

const setGroupPageFeedTabStart = (state, { feedTab }) => ({
    ...state,
    feedTab,
    showViewPost: false,
    showViewAnnouncement: false,
    showGeneralErrorAlert: false
});

const saveGroupAnnouncement = (state) => {
    return {
        ...state,
        postingGroupAnnouncement: true,
        postingGroupAnnouncementSuccess: false,
        postingGroupAnnouncementError: false,
        showViewAnnouncement: false
    };
};

const saveGroupAnnouncementSuccess = (state, action) => {
    return {
        ...state,
        groupAnnouncement: action.groupAnnouncement,
        groupAnnouncementRenderKey: Date.now(),
        postingGroupAnnouncement: false,
        postingGroupAnnouncementSuccess: true,
        groupPostImages: [],
        groupPostImageLastIndex: null,
        showViewAnnouncement: state.feedTab === FEED_TAB_TYPE.ACTIVITIES ? true : false,
        showViewPost: false
    };
};

const saveGroupAnnouncementFailed = (state) => {
    return {
        ...state,
        postingGroupAnnouncement: false,
        postingGroupAnnouncementError: true
    };
};

const deleteGroupAnnouncementSuccess = (state) => {
    return {
        ...state,
        groupAnnouncement: null,
        allFeeds:
            state.feedTab === FEED_TAB_TYPE.ALL
                ? {
                      ...state.allFeeds,
                      list: state.allFeeds.list.map((feed) => ({
                          ...feed,
                          data: {
                              ...feed.data,
                              shouldAnimateUp: true
                          }
                      }))
                  }
                : state.allFeeds,
        groupPosts:
            state.feedTab === FEED_TAB_TYPE.POSTS
                ? {
                      ...state.groupPosts,
                      list: state.groupPosts.list.map((post) => ({
                          ...post,
                          shouldAnimateUp: true
                      }))
                  }
                : state.groupPosts,
        showGeneralErrorAlert: false
    };
};

const deleteGroupAnnouncementFailed = (state) => {
    return {
        ...state,
        showGeneralErrorAlert: true
    };
};

const saveGroupPost = (state) => {
    return {
        ...state,
        postingGroupPost: true,
        postingGroupPostSuccess: false,
        postingGroupPostError: false,
        showViewPost: false
    };
};

const saveGroupPostSuccess = (state, { newPost }) => {
    return {
        ...state,
        groupAnnouncementRenderKey: Date.now(),
        postingGroupPost: false,
        postingGroupPostSuccess: true,
        allFeeds: {
            ...state.allFeeds,
            list: [{ groupFeedType: ALL_FEED_TYPE.post, data: newPost }, ...state.allFeeds.list]
        },
        groupPosts: state.groupPosts.success
            ? {
                  ...state.groupPosts,
                  list: [newPost, ...state.groupPosts.list]
              }
            : state.groupPosts,
        groupPostImages: [],
        groupPostImageEditMode: false,
        groupPostImageLastIndex: null,
        showViewPost: state.feedTab === FEED_TAB_TYPE.ACTIVITIES ? true : false,
        showViewAnnouncement: false
    };
};

const saveGroupPostFailed = (state) => {
    return {
        ...state,
        postingGroupPost: false,
        postingGroupPostError: true
    };
};

const deleteGroupPost = (state, action) => {
    return {
        ...state,
        uiPostState: {
            ...state.uiPostState,
            [action.postUuid]: {
                deleting: true,
                error: false
            }
        }
    };
};

const deleteGroupPostSuccess = (state, { postUuid }) => {
    // We're going to animate Posts that are after the deleted one
    const animatePostIndex = state.groupPosts.list.findIndex((post) => post.uuid === postUuid);
    const animateAllIndex = state.allFeeds.list.findIndex(
        (feed) => feed.groupFeedType === ALL_FEED_TYPE.post && feed.data.uuid === postUuid
    );

    const resourceKey = `${RESOURCE_TYPE.post}/${postUuid}`;
    const newAllFeedsList = state.allFeeds.list
        .filter(
            (feed) =>
                feed.groupFeedType === ALL_FEED_TYPE.activity ||
                (feed.groupFeedType === ALL_FEED_TYPE.post && feed.data.uuid !== postUuid)
        )
        .map((feed, index) => ({
            ...feed,
            data: {
                ...feed.data,
                shouldAnimateUp: index >= animateAllIndex
            }
        }));
    const newGroupPostsList = state.groupPosts.list
        .filter((post) => post.uuid !== postUuid)
        .map((post, index) => ({
            ...post,
            shouldAnimateUp: index >= animatePostIndex
        }));
    const newComments = omitInState(state.comments, resourceKey);
    const newHighlightedComments = omitInState(state.highlightedComments, resourceKey);
    const newUiPostState = omitInState(state.uiPostState, resourceKey);
    const newUiCommentsState = omitInState(state.uiCommentsState, resourceKey);
    const newUiAddCommentState = omitInState(state.uiAddCommentState, resourceKey);
    const newUiCommentState = omitInState(state.uiCommentState, resourceKey);
    const newConversationLikers = omitInState(state.conversationLikers, resourceKey);
    const newCommentLikers = omitInState(state.commentLikers, resourceKey);

    return {
        ...state,
        allFeeds: {
            ...state.allFeeds,
            list: newAllFeedsList
        },
        groupPosts: {
            ...state.groupPosts,
            list: newGroupPostsList
        },
        comments: newComments,
        highlightedComments: newHighlightedComments,
        uiPostState: newUiPostState,
        uiCommentsState: newUiCommentsState,
        uiAddCommentState: newUiAddCommentState,
        uiCommentState: newUiCommentState,
        conversationLikers: newConversationLikers,
        commentLikers: newCommentLikers,
        showGeneralErrorAlert: false
    };
};

const deleteGroupPostFailed = (state, action) => {
    return {
        ...state,
        uiPostState: {
            ...state.uiPostState,
            [action.postUuid]: {
                deleting: false,
                error: true
            }
        },
        showGeneralErrorAlert: true
    };
};

const fetchGroupPosts = (state, action) => {
    return {
        ...state,
        groupPosts: {
            ...state.groupPosts,
            fetching: true,
            success: false,
            error: false
        },
        showGeneralErrorAlert: false
    };
};

const fetchGroupPostsSuccess = (state, { posts, hasMore, cursor }) => {
    const highlightedComments = { ...state.highlightedComments };
    posts.forEach((post) => {
        const { highlightedCommentDTO, uuid } = post;
        const resourceKey = `${RESOURCE_TYPE.post}/${uuid}`;
        if (highlightedCommentDTO) {
            highlightedComments[resourceKey] = [highlightedCommentDTO];
        }
    });
    return {
        ...state,
        groupPosts: {
            ...state.groupPosts,
            list: [...state.groupPosts.list, ...posts],
            fetching: false,
            success: true,
            hasMore,
            cursor
        },
        highlightedComments
    };
};

const fetchGroupPostsFailed = (state) => {
    return {
        ...state,
        groupPosts: {
            ...state.groupPosts,
            fetching: false,
            error: true
        },
        showGeneralErrorAlert: true
    };
};

const fetchGroupPostStart = (state) => ({
    ...state,
    groupPosts: {
        ...INITIAL_STATE.groupPosts,
        fetching: true
    }
});

const fetchGroupPostSuccess = (state, { post }) => {
    const highlightedComments = { ...state.highlightedComments };
    const { highlightedCommentDTO, uuid } = post;
    const resourceKey = `${RESOURCE_TYPE.post}/${uuid}`;
    if (highlightedCommentDTO) {
        highlightedComments[resourceKey] = [highlightedCommentDTO];
    }
    return {
        ...state,
        groupPosts: {
            ...state.groupPosts,
            list: [post],
            fetching: false,
            success: true
        },
        highlightedComments
    };
};

const fetchGroupPostFailed = (state, { errorStatus }) => ({
    ...state,
    groupPosts: {
        ...state.groupPosts,
        fetching: false,
        error: true
    },
    singlePageErrorStatus: errorStatus
});

const fetchGroupComments = (state, action) => {
    const { resourceType, resourceId } = action;
    const resourceKey = `${resourceType}/${resourceId}`;
    let newUiState = {
        resourceType,
        id: resourceId,
        nextCursor: 0,
        ...state.uiCommentsState[resourceKey],
        fetching: true,
        error: false
    };
    return {
        ...state,
        uiCommentsState: {
            ...state.uiCommentsState,
            [resourceKey]: newUiState
        }
    };
};

const fetchGroupCommentsSuccess = (state, action) => {
    const { resourceType, resourceId, hasMore, comments } = action;
    const resourceKey = `${resourceType}/${resourceId}`;

    let newUiState = {
        ...state.uiCommentsState[resourceKey],
        hasMore,
        fetching: false,
        error: false,
        initialFetchDone: true
    };
    let newComments;
    if (state.comments[resourceKey]) {
        newComments = [...comments, ...state.comments[resourceKey]];
    } else {
        newComments = comments;
    }

    return {
        ...state,
        uiCommentsState: {
            ...state.uiCommentsState,
            [resourceKey]: newUiState
        },
        comments: {
            ...state.comments,
            [resourceKey]: newComments
        }
    };
};

const fetchGroupCommentsFailed = (state, action) => {
    const { resourceType, resourceId } = action;
    const resourceKey = `${resourceType}/${resourceId}`;
    const newUiState = {
        ...state.uiCommentsState[resourceKey],
        fetching: false,
        error: true
    };
    return {
        ...state,
        uiCommentsState: {
            ...state.uiCommentsState,
            [resourceKey]: newUiState
        }
    };
};

const saveGroupComment = (state, action) => {
    const { resourceType, resourceId } = action;
    const resourceKey = `${resourceType}/${resourceId}`;
    const newUiState = {
        ...state.uiAddCommentState[resourceKey],
        success: false,
        error: false,
        submitting: true
    };
    return {
        ...state,
        uiAddCommentState: {
            ...state.uiAddCommentState,
            [resourceKey]: newUiState
        },
        showCommentError: false,
        showGeneralErrorAlert: false
    };
};

/**
 * Updates states:
 * 1. uiAddCommentState ....... Update add comment states
 * 2. comments ................ Append new comment
 * 3. highlightedComments ..... Append new comment to highlighted comments
 * 4. allFeeds ................ Increase numberOfActivityComments/numberOfComments of target activity/post by one
 * 5. activityFeed ............ Increase numberOfActivityComments of target activity in activityFeed by one
 * 6. groupPosts .............. Increase numberOfComments of target post by one
 */
const saveGroupCommentSuccess = (state, action) => {
    const { resourceType, resourceId, newComment } = action;
    const resourceKey = `${resourceType}/${resourceId}`;

    return {
        ...state,
        uiAddCommentState: {
            ...state.uiAddCommentState,
            [resourceKey]: {
                submitting: false,
                success: true,
                error: false
            }
        },
        comments: {
            ...state.comments,
            [resourceKey]: state.comments[resourceKey] ? [...state.comments[resourceKey], newComment] : [newComment]
        },
        highlightedComments: {
            ...state.highlightedComments,
            [resourceKey]: state.highlightedComments[resourceKey]
                ? [...state.highlightedComments[resourceKey], newComment]
                : [newComment]
        },
        allFeeds: {
            ...state.allFeeds,
            list: state.allFeeds.list.map((feed) => {
                const { data, groupFeedType } = feed;
                if (groupFeedType === ALL_FEED_TYPE.activity && data.activityId === resourceId) {
                    return {
                        ...feed,
                        data: {
                            ...data,
                            numberOfActivityComments: data.numberOfActivityComments + 1
                        }
                    };
                } else if (groupFeedType === ALL_FEED_TYPE.post && data.uuid === resourceId) {
                    return {
                        ...feed,
                        data: {
                            ...data,
                            conversationDTO: data.conversationDTO
                                ? {
                                      ...data.conversationDTO,
                                      numberOfComments: data.conversationDTO.numberOfComments + 1
                                  }
                                : {
                                      conversationUuid: newComment.conversationUuid,
                                      numberOfComments: 1,
                                      numberOfLikes: 0,
                                      likedByUser: false
                                  }
                        }
                    };
                }
                return feed;
            })
        },
        activityFeed: {
            ...state.activityFeed,
            list: state.activityFeed.list.map((activity) => {
                if (activity.activityId === resourceId) {
                    return {
                        ...activity,
                        numberOfActivityComments: activity.numberOfActivityComments + 1
                    };
                }
                return activity;
            })
        },
        groupPosts: {
            ...state.groupPosts,
            list: state.groupPosts.list.map((post) => {
                if (post.uuid === resourceId) {
                    return {
                        ...post,
                        conversationDTO: post.conversationDTO
                            ? {
                                  ...post.conversationDTO,
                                  numberOfComments: post.conversationDTO.numberOfComments + 1
                              }
                            : {
                                  conversationUuid: newComment.conversationUuid,
                                  numberOfComments: 1,
                                  numberOfLikes: 0,
                                  likedByUser: false
                              }
                    };
                }
                return post;
            })
        }
    };
};

const saveGroupCommentFailed = (state, action) => {
    const { resourceType, resourceId, errorReachLimit } = action;
    const resourceKey = `${resourceType}/${resourceId}`;
    const newUiState = {
        submitting: false,
        error: true
    };

    return {
        ...state,
        uiAddCommentState: {
            ...state.uiAddCommentState,
            [resourceKey]: newUiState
        },
        showCommentError: !errorReachLimit,
        showGeneralErrorAlert: !errorReachLimit
    };
};

const editGroupCommentStart = (state, action) => {
    const { conversationCommentUuid } = action;
    return {
        ...state,
        uiEditCommentState: {
            ...state.uiEditCommentState,
            [conversationCommentUuid]: {
                editing: true,
                editSuccess: false,
                editError: false
            }
        },
        showCommentError: false,
        showGeneralErrorAlert: false
    };
};

const editGroupCommentSuccess = (state, action) => {
    const { resourceType, resourceId, newComment, conversationCommentUuid } = action;
    const resourceKey = `${resourceType}/${resourceId}`;

    return {
        ...state,
        uiEditCommentState: {
            ...state.uiEditCommentState,
            [conversationCommentUuid]: {
                editing: false,
                editSuccess: true,
                editError: false
            }
        },
        comments: {
            ...state.comments,
            [resourceKey]: Array.isArray(state.comments[resourceKey])
                ? state.comments[resourceKey].map((comment) => {
                      if (comment.conversationCommentPk === newComment.conversationCommentPk) {
                          return newComment;
                      }
                      return comment;
                  })
                : state.comments[resourceKey]
        },
        highlightedComments: {
            ...state.highlightedComments,
            [resourceKey]: Array.isArray(state.highlightedComments[resourceKey])
                ? state.highlightedComments[resourceKey].map((comment) => {
                      if (comment.conversationCommentPk === newComment.conversationCommentPk) {
                          return newComment;
                      }
                      return comment;
                  })
                : state.highlightedComments[resourceKey]
        }
    };
};

const editGroupCommentFailed = (state, action) => {
    const { conversationCommentUuid } = action;
    return {
        ...state,
        uiEditCommentState: {
            ...state.uiEditCommentState,
            [conversationCommentUuid]: {
                editing: false,
                editSuccess: false,
                editError: true
            }
        },
        showCommentError: true,
        showGeneralErrorAlert: true
    };
};

const deleteGroupComment = (state, action) => {
    const { resourceType, resourceId } = action;
    const resourceKey = `${resourceType}/${resourceId}`;
    const { conversationUuid, conversationCommentUuid } = action.comment;
    const commentKey = `${conversationUuid}/${conversationCommentUuid}`;
    return {
        ...state,
        uiCommentState: {
            ...state.uiCommentState,
            [resourceKey]: {
                ...state.uiCommentState[resourceKey],
                [commentKey]: {
                    deleting: true,
                    error: false
                }
            }
        },
        showGeneralErrorAlert: false
    };
};

const deleteGroupCommentSuccess = (state, action) => {
    const { resourceType, resourceId, comment } = action;
    const resourceKey = `${resourceType}/${resourceId}`;
    const { conversationUuid, conversationCommentUuid } = comment;
    const commentKey = `${conversationUuid}/${conversationCommentUuid}`;

    const newGroupComments = (state.comments[resourceKey] || []).filter(
        (item) => item.conversationCommentUuid !== conversationCommentUuid
    );
    const newCommentState = omitInState(state.uiCommentState[resourceKey], commentKey);
    const newCommentLikerState = omitInState(state.commentLikers[resourceKey], conversationCommentUuid);

    const newHighlightedComments = (state.highlightedComments[resourceKey] || []).filter(
        (comment) => comment.conversationCommentUuid !== conversationCommentUuid
    );

    return {
        ...state,
        comments: {
            ...state.comments,
            [resourceKey]: newGroupComments
        },
        uiCommentState: {
            ...state.uiCommentState,
            [resourceKey]: newCommentState
        },
        commentLikers: {
            ...state.commentLikers,
            [resourceKey]: newCommentLikerState
        },
        allFeeds: {
            ...state.allFeeds,
            list: state.allFeeds.list.map((feed) => {
                const { data, groupFeedType } = feed;
                if (groupFeedType === ALL_FEED_TYPE.activity && data.activityId === resourceId) {
                    return {
                        ...feed,
                        data: {
                            ...data,
                            numberOfActivityComments: data.numberOfActivityComments - 1
                        }
                    };
                } else if (groupFeedType === ALL_FEED_TYPE.post && data.uuid === resourceId) {
                    return {
                        ...feed,
                        data: {
                            ...data,
                            conversationDTO: {
                                ...data.conversationDTO,
                                numberOfComments: data.conversationDTO.numberOfComments - 1
                            }
                        }
                    };
                }
                return feed;
            })
        },
        activityFeed: {
            ...state.activityFeed,
            list: state.activityFeed.list.map((activity) => {
                if (activity.activityId === resourceId) {
                    return {
                        ...activity,
                        numberOfActivityComments: activity.numberOfActivityComments - 1
                    };
                }
                return activity;
            })
        },
        groupPosts: {
            ...state.groupPosts,
            list: state.groupPosts.list.map((post) => {
                if (post.uuid === resourceId) {
                    return {
                        ...post,
                        conversationDTO: {
                            ...post.conversationDTO,
                            numberOfComments: post.conversationDTO.numberOfComments - 1
                        }
                    };
                }
                return post;
            })
        },
        highlightedComments: {
            ...state.highlightedComments,
            [resourceKey]: newHighlightedComments
        }
    };
};

const deleteGroupCommentFailed = (state, action) => {
    const { resourceType, resourceId } = action;
    const resourceKey = `${resourceType}/${resourceId}`;
    const { conversationUuid, conversationCommentUuid } = action.comment;
    const commentKey = `${conversationUuid}/${conversationCommentUuid}`;
    return {
        ...state,
        uiCommentState: {
            ...state.uiCommentState,
            [resourceKey]: {
                ...state.uiCommentState[resourceKey],
                [commentKey]: {
                    deleting: true,
                    error: false
                }
            }
        },
        showGeneralErrorAlert: true
    };
};

const openDeleteConfirmDialog = (state, action) => {
    return {
        ...state,
        deleteDialog: {
            open: true,
            deleteType: action.deleteType,
            postUuid: action.postUuid || null,
            course: action.course || null,
            postImage: action.postImage || null
        }
    };
};

const closeDeleteConfirmDialog = (state) => {
    return {
        ...state,
        deleteDialog: {
            open: false
        }
    };
};

const fetchGroupConversationLikers = (state, action) => {
    const { resourceType, resourceId } = action;
    const resourceKey = `${resourceType}/${resourceId}`;
    return {
        ...state,
        conversationLikers: {
            ...state.conversationLikers,
            [resourceKey]: {
                ...state.conversationLikers[resourceKey],
                fetching: true,
                success: false,
                error: false
            }
        }
    };
};

const fetchGroupConversationLikersDone = (state, action) => {
    const { resourceType, resourceId } = action;
    const resourceKey = `${resourceType}/${resourceId}`;
    return {
        ...state,
        conversationLikers: {
            ...state.conversationLikers,
            [resourceKey]: {
                ...state.conversationLikers[resourceKey],
                likers: action.likers,
                fetching: false,
                success: !action.error,
                error: action.error
            }
        }
    };
};

const updateGroupConversationLikeStart = (state, action) => {
    const { resourceType, resourceId } = action;
    const resourceKey = `${resourceType}/${resourceId}`;
    return {
        ...state,
        conversationLikers: {
            ...state.conversationLikers,
            [resourceKey]: {
                ...state.conversationLikers[resourceKey],
                updating: true
            }
        },
        showGeneralErrorAlert: false
    };
};

const updateGroupConversationLikeDone = (state, action) => {
    const {
        resourceType,
        resourceId,
        like,
        likerInfo,
        conversationUuid,
        error,
        errorReachLimit,
        conversationLikeDto
    } = action;
    const resourceKey = `${resourceType}/${resourceId}`;

    if (error) {
        return {
            ...state,
            conversationLikers: {
                ...state.conversationLikers,
                [resourceKey]: {
                    ...state.conversationLikers[resourceKey],
                    updating: false,
                    success: false,
                    error: true
                }
            },
            showGeneralErrorAlert: !errorReachLimit
        };
    }

    const getActivityNewLikeStates = (activity, likerInfo) => {
        const {
            numberOfActivityLikes,
            activityLikeDisplayNames,
            activityLikeFullNames,
            activityLikeProfileImageUrls,
            activityLikeUserIds
        } = activity;
        const { profileImageUrlSmall, fullName, displayName, profileId } = likerInfo;

        const newNumberOfActivityLikes = numberOfActivityLikes || 0; // prevent null

        return {
            likedByUser: like,
            numberOfActivityLikes: like ? newNumberOfActivityLikes + 1 : newNumberOfActivityLikes - 1,
            activityLikeDisplayNames: like
                ? (activityLikeDisplayNames || []).concat(displayName)
                : activityLikeDisplayNames.filter((likerDisplayName) => likerDisplayName !== displayName),
            activityLikeFullNames: like
                ? (activityLikeFullNames || []).concat(fullName)
                : activityLikeFullNames.filter((likerFullName) => likerFullName !== fullName),
            activityLikeProfileImageUrls: like
                ? (activityLikeProfileImageUrls || []).concat(profileImageUrlSmall)
                : activityLikeProfileImageUrls.filter((imageUrl) => imageUrl !== profileImageUrlSmall),
            activityLikeUserIds: like
                ? (activityLikeUserIds || []).concat(profileId)
                : activityLikeUserIds.filter((item) => item !== profileId),
            conversationUuid: conversationUuid
                ? conversationUuid
                : activity.conversationUuid || conversationLikeDto.conversationUuid
        };
    };

    const getPostNewLikeStates = (post, likerInfo) => {
        let newConversationDTO;
        let newConversationLikersDTO;

        const { profileImageUrlSmall, fullName, displayName, profileId } = likerInfo;
        const prevNumberOfLikes = (post.conversationDTO && post.conversationDTO.numberOfLikes) || 0;

        if (like) {
            newConversationDTO = post.conversationDTO
                ? {
                      ...post.conversationDTO,
                      numberOfLikes: prevNumberOfLikes + 1,
                      likedByUser: true
                  }
                : {
                      conversationUuid,
                      numberOfComments: 0,
                      numberOfLikes: 1,
                      likedByUser: true
                  };
            newConversationLikersDTO = {
                likerDisplayNames: (
                    (post.conversationLikersDTO && post.conversationLikersDTO.likerDisplayNames) ||
                    []
                ).concat(displayName),
                likerFullNames: (
                    (post.conversationLikersDTO && post.conversationLikersDTO.likerFullNames) ||
                    []
                ).concat(fullName),
                likerProfileImageUrls: (
                    (post.conversationLikersDTO && post.conversationLikersDTO.likerProfileImageUrls) ||
                    []
                ).concat(profileImageUrlSmall),
                likerUserIds: (post.conversationLikersDTO?.likerUserIds || []).concat(profileId)
            };
        } else {
            newConversationDTO = {
                ...post.conversationDTO,
                numberOfLikes: prevNumberOfLikes - 1,
                likedByUser: false
            };
            newConversationLikersDTO = {
                ...post.conversationLikersDTO,
                likerDisplayNames: post.conversationLikersDTO.likerDisplayNames.filter(
                    (likerDisplayName) => likerDisplayName !== displayName
                ),
                likerFullNames: post.conversationLikersDTO.likerFullNames.filter(
                    (likerFullName) => likerFullName !== fullName
                ),
                likerProfileImageUrls: post.conversationLikersDTO.likerProfileImageUrls.filter(
                    (imageUrl) => imageUrl !== profileImageUrlSmall
                ),
                likerUserIds: (post.conversationLikersDTO?.likerUserIds || []).filter((item) => item !== profileId)
            };
        }

        return {
            ...post,
            conversationDTO: newConversationDTO,
            conversationLikersDTO: newConversationLikersDTO
        };
    };

    return {
        ...state,
        conversationLikers: {
            ...state.conversationLikers,
            [resourceKey]: {
                ...state.conversationLikers[resourceKey],
                updating: false,
                success: true,
                error: false
            }
        },
        allFeeds: {
            ...state.allFeeds,
            list: state.allFeeds.list.map((feed) => {
                const { data, groupFeedType } = feed;
                if (groupFeedType === ALL_FEED_TYPE.activity && data.activityId === resourceId) {
                    return {
                        ...feed,
                        data: {
                            ...data,
                            ...getActivityNewLikeStates(data, likerInfo)
                        }
                    };
                } else if (groupFeedType === ALL_FEED_TYPE.post && data.uuid === resourceId) {
                    return {
                        ...feed,
                        data: {
                            ...data,
                            ...getPostNewLikeStates(data, likerInfo)
                        }
                    };
                }
                return feed;
            })
        },
        activityFeed: {
            ...state.activityFeed,
            list: state.activityFeed.list.map((activity) => {
                if (activity.activityId === resourceId) {
                    return {
                        ...activity,
                        ...getActivityNewLikeStates(activity, likerInfo)
                    };
                }
                return activity;
            })
        },
        groupPosts: {
            ...state.groupPosts,
            list: state.groupPosts.list.map((post) => {
                if (post.uuid === resourceId) {
                    return {
                        ...post,
                        ...getPostNewLikeStates(post, likerInfo)
                    };
                }
                return post;
            })
        }
    };
};

const fetchGroupCommentLikers = (state, action) => {
    const { resourceType, resourceId, conversationCommentUuid } = action;
    const resourceKey = `${resourceType}/${resourceId}`;
    let oldState = {};
    if (state.commentLikers[resourceKey]) {
        oldState = state.commentLikers[resourceKey][conversationCommentUuid] || {};
    }
    return {
        ...state,
        commentLikers: {
            ...state.commentLikers,
            [resourceKey]: {
                ...state.commentLikers[resourceKey],
                [conversationCommentUuid]: {
                    ...oldState,
                    fetching: true,
                    success: false,
                    error: false
                }
            }
        }
    };
};

const fetchGroupCommentLikersDone = (state, action) => {
    const { resourceType, resourceId, conversationCommentUuid } = action;
    const resourceKey = `${resourceType}/${resourceId}`;
    let oldState = {};
    if (state.commentLikers[resourceKey]) {
        oldState = state.commentLikers[resourceKey][conversationCommentUuid] || {};
    }
    return {
        ...state,
        commentLikers: {
            ...state.commentLikers,
            [resourceKey]: {
                ...state.commentLikers[resourceKey],
                [conversationCommentUuid]: {
                    ...oldState,
                    likers: action.likers,
                    fetching: false,
                    success: !action.error,
                    error: action.error
                }
            }
        }
    };
};

const updateGroupCommentLikeStart = (state, action) => {
    const { resourceType, resourceId, conversationCommentUuid } = action;
    const resourceKey = `${resourceType}/${resourceId}`;
    let oldState = {};
    if (state.commentLikers[resourceKey]) {
        oldState = state.commentLikers[resourceKey][conversationCommentUuid] || {};
    }
    return {
        ...state,
        commentLikers: {
            ...state.commentLikers,
            [resourceKey]: {
                ...state.commentLikers[resourceKey],
                [conversationCommentUuid]: {
                    ...oldState,
                    updating: true
                }
            }
        },
        showGeneralErrorAlert: false
    };
};

const updateGroupCommentLikeDone = (state, action) => {
    const { resourceType, resourceId, conversationCommentUuid, like, likeDto, error, errorReachLimit } = action;
    const resourceKey = `${resourceType}/${resourceId}`;
    let oldState = {};
    if (state.commentLikers[resourceKey]) {
        oldState = state.commentLikers[resourceKey][conversationCommentUuid] || {};
    }

    if (error) {
        return {
            ...state,
            commentLikers: {
                ...state.commentLikers,
                [resourceKey]: {
                    ...state.commentLikers[resourceKey],
                    [conversationCommentUuid]: {
                        ...oldState,
                        updating: false,
                        error
                    }
                }
            },
            showGeneralErrorAlert: !errorReachLimit
        };
    }

    const updateCommentLikers = Array.isArray(oldState.likers);
    const updateComments =
        Array.isArray(state.comments[resourceKey]) &&
        state.comments[resourceKey].some((comment) => comment.conversationCommentUuid === conversationCommentUuid);
    const updateHighlightedComments =
        Array.isArray(state.highlightedComments[resourceKey]) &&
        state.highlightedComments[resourceKey].some(
            (comment) => comment.conversationCommentUuid === conversationCommentUuid
        );

    let newLikers = [];
    if (updateCommentLikers) {
        newLikers = like
            ? oldState.likers.concat(likeDto)
            : oldState.likers.filter((liker) => liker.displayName !== state.viewerSocialProfile.displayName);
    }

    let newComments = state.comments;
    if (updateComments) {
        newComments = {
            ...state.comments,
            [resourceKey]: state.comments[resourceKey].map((comment) => {
                if (comment.conversationCommentUuid === conversationCommentUuid) {
                    return {
                        ...comment,
                        likedByUser: like,
                        numberOfLikes: like ? comment.numberOfLikes + 1 : comment.numberOfLikes - 1
                    };
                }
                return comment;
            })
        };
    }

    let newHighlightedComments = state.highlightedComments;
    if (updateHighlightedComments) {
        newHighlightedComments = {
            ...state.highlightedComments,
            [resourceKey]: state.highlightedComments[resourceKey].map((comment) => {
                if (comment.conversationCommentUuid === conversationCommentUuid) {
                    return {
                        ...comment,
                        likedByUser: like,
                        numberOfLikes: like ? comment.numberOfLikes + 1 : comment.numberOfLikes - 1,
                        likerFullNames: like
                            ? (comment.likerFullNames || []).concat(state.viewerSocialProfile.userProfileFullName)
                            : (comment.likerFullNames || []).filter(
                                  (name) => name !== state.viewerSocialProfile.userProfileFullName
                              )
                    };
                }
                return comment;
            })
        };
    }

    return {
        ...state,
        commentLikers: {
            ...state.commentLikers,
            [resourceKey]: {
                ...state.commentLikers[resourceKey],
                [conversationCommentUuid]: {
                    ...oldState,
                    updating: false,
                    error,
                    likers: newLikers
                }
            }
        },
        comments: newComments,
        highlightedComments: newHighlightedComments
    };
};

const fetchGroupAllFeedsStart = (state) => {
    return {
        ...state,
        allFeeds: {
            ...state.allFeeds,
            fetching: true,
            success: false,
            error: false
        },
        showGeneralErrorAlert: false
    };
};

const fetchGroupAllFeedsSuccess = (state, { list, hasMore, cursor, daysLimit }) => {
    const highlightedComments = { ...state.highlightedComments };
    list.forEach((feed) => {
        const { data, groupFeedType } = feed;
        const isActivity = groupFeedType === ALL_FEED_TYPE.activity;
        const type = isActivity ? RESOURCE_TYPE.activity : RESOURCE_TYPE.post;
        const id = isActivity ? data.activityId : data.uuid;
        const highlightedComment = isActivity ? data.highlightedComment : data.highlightedCommentDTO;
        const resourceKey = `${type}/${id}`;
        if (highlightedComment) {
            highlightedComments[resourceKey] = [highlightedComment];
        }
    });

    return {
        ...state,
        allFeeds: {
            ...state.allFeeds,
            fetching: false,
            success: true,
            error: false,
            list: [...state.allFeeds.list, ...list],
            hasMore,
            cursor,
            daysLimit
        },
        highlightedComments
    };
};

const fetchGroupAllFeedsFailed = (state) => {
    return {
        ...state,
        allFeeds: {
            ...state.allFeeds,
            fetching: false,
            success: false,
            error: true
        },
        showGeneralErrorAlert: true
    };
};

const fetchGroupActivityFeeds = (state) => {
    return {
        ...state,
        activityFeed: {
            ...state.activityFeed,
            fetching: true,
            success: false,
            error: false
        },
        showGeneralErrorAlert: false
    };
};

const fetchGroupActivityFeedsSuccess = (state, { list, hasMore, cursor, daysLimit }) => {
    const highlightedComments = { ...state.highlightedComments };
    list.forEach((activity) => {
        const { highlightedComment, activityId } = activity;
        const resourceKey = `${RESOURCE_TYPE.activity}/${activityId}`;
        if (highlightedComment) {
            highlightedComments[resourceKey] = [highlightedComment];
        }
    });

    return {
        ...state,
        activityFeed: {
            ...state.activityFeed,
            fetching: false,
            success: true,
            error: false,
            list: [...state.activityFeed.list, ...list],
            hasMore,
            cursor,
            daysLimit
        },
        highlightedComments
    };
};

const fetchGroupActivityFeedsFailed = (state) => {
    return {
        ...state,
        activityFeed: {
            ...state.activityFeed,
            fetching: false,
            success: false,
            error: true
        },
        showGeneralErrorAlert: true
    };
};

const fetchGroupActivityFeedStart = (state) => ({
    ...state,
    activityFeed: {
        ...state.activityFeed,
        fetching: true,
        error: false,
        list: INITIAL_STATE.activityFeed.list
    }
});

const fetchGroupActivityFeedSuccess = (state, { activity }) => {
    const highlightedComments = { ...state.highlightedComments };
    const { highlightedComment, activityId } = activity;
    const resourceKey = `${RESOURCE_TYPE.activity}/${activityId}`;
    if (highlightedComment) {
        highlightedComments[resourceKey] = [highlightedComment];
    }
    return {
        ...state,
        activityFeed: {
            ...state.activityFeed,
            list: [activity],
            fetching: false,
            error: false
        },
        highlightedComments
    };
};

const fetchGroupActivityFeedFailed = (state, { errorStatus }) => ({
    ...state,
    activityFeed: {
        ...state.activityFeed,
        fetching: false,
        error: true
    },
    singlePageErrorStatus: errorStatus
});

const joinGroupSuccess = (state, action) => {
    const { member, groupAnnouncement } = action;
    const memberConnection = {
        connectionRequestId: null,
        connectionRequestorId: null,
        connectionStatus: 0,
        userProfileId: member.userProfileId,
        groupRole: GROUP_ROLE.MEMBER
    };
    return {
        ...state,
        groupMembers: [...state.groupMembers, member],
        groupUserConnections: [...state.groupUserConnections, memberConnection],
        group: {
            ...state.group,
            membershipStatus: GROUP_ROLE.MEMBER
        },
        groupAnnouncement
    };
};

const acceptInvitationSuccess = (state, { members, groupAnnouncement, userConnection }) => ({
    ...state,
    groupMembers: members,
    groupUserConnections: [...state.groupUserConnections, userConnection],
    group: {
        ...state.group,
        membershipStatus: GROUP_ROLE.MEMBER
    },
    groupAnnouncement
});

const updateGroupMemberRequest = (state, action) => {
    return {
        ...state,
        groupMemberRequest: action.groupMemberRequest
    };
};

const updateGroupMembers = (state, action) => {
    return {
        ...state,
        groupMembers: action.groupMembers || []
    };
};

const sortGroupMembers = (state) => {
    const { viewerSocialProfile, groupMembers, groupUserConnections } = state;
    const { profileId } = viewerSocialProfile;
    const userAuthenticated = !!(viewerSocialProfile && profileId);

    const sortByGroupRole = (a, b) => {
        if (
            b.groupRole === GROUP_ROLE.OWNER ||
            (b.groupRole === GROUP_ROLE.ADMIN && a.groupRole === GROUP_ROLE.MEMBER)
        ) {
            return 1;
        } else if (
            a.groupRole === GROUP_ROLE.OWNER ||
            (a.groupRole === GROUP_ROLE.ADMIN && b.groupRole === GROUP_ROLE.MEMBER)
        ) {
            return -1;
        }
        return 0;
    };

    // if user is viewing the group detail page without logging in, just sort the members from API endpoint by group role
    if (!userAuthenticated) {
        return {
            ...state,
            groupViewerMember: [],
            groupConnectionMembers: [],
            groupNonConnectionMembers: groupMembers.sort(sortByGroupRole)
        };
    }

    return {
        ...state,
        groupViewerMember: groupMembers.filter((member) => member.userProfileId === profileId),
        groupConnectionMembers: groupMembers
            .filter((member) => {
                const { connectionStatus } = groupUserConnections.find(
                    (connection) => connection.userProfileId === member.userProfileId
                );
                return isStatusAccepted(connectionStatus);
            })
            .sort(sortByGroupRole),
        groupNonConnectionMembers: groupMembers
            .filter((member) => profileId !== member.userProfileId)
            .filter((member) => {
                const { connectionStatus } = groupUserConnections.find(
                    (connection) => connection.userProfileId === member.userProfileId
                );
                return !isStatusAccepted(connectionStatus);
            })
            .sort(sortByGroupRole)
    };
};

const updateGroupUserConnections = (state, action) => {
    return {
        ...state,
        groupUserConnections: action.groupUserConnections
    };
};

const updateGroupUserConnectionDone = (state, action) => {
    const { groupUserConnection } = action;

    return {
        ...state,
        groupUserConnections: state.groupUserConnections.map((connection) => {
            if (connection.userProfileId === groupUserConnection.userProfileId) {
                return groupUserConnection;
            }
            return connection;
        })
    };
};

const updateGroupInvites = (state, action) => {
    const newGroupRejectedInvites = action.groupRejectedInvites;
    newGroupRejectedInvites.sort((itemA, itemB) => {
        return itemB.inviteDate - itemA.inviteDate;
    });
    return {
        ...state,
        groupInvites: action.groupInvites,
        groupRejectedInvites: newGroupRejectedInvites
    };
};

const cancelInviteUserDone = (state, action) => {
    if (action.error) {
        return state;
    }
    return {
        ...state,
        groupInvites: state.groupInvites.filter((item) => item.inviteeId !== action.connection.userId)
    };
};

const inviteUserDone = (state, action) => {
    if (action.error) {
        return state;
    }
    return {
        ...state,
        groupInvites: [...state.groupInvites, action.newInvite]
    };
};

const removeGroupMemberSuccess = (state, action) => {
    const { userProfileId } = action;
    return {
        ...state,
        groupMembers: state.groupMembers.filter((member) => member.userProfileId !== userProfileId),
        groupUserConnections: state.groupUserConnections.filter(
            (connection) => connection.userProfileId !== userProfileId
        ),
        groupConnectionMembers: state.groupConnectionMembers.filter((member) => member.userProfileId !== userProfileId),
        groupNonConnectionMembers: state.groupNonConnectionMembers.filter(
            (member) => member.userProfileId !== userProfileId
        )
    };
};

const removeGroupMemberFailed = (state) => state;

const updateGroupMemberRoleSuccess = (state, action) => {
    const { updatedMember } = action;

    return {
        ...state,
        groupMembers: state.groupMembers.map((member) => {
            if (member.userProfileId === updatedMember.userProfileId) {
                return updatedMember;
            }
            return member;
        }),
        group: {
            ...state.group,
            membershipStatus:
                updatedMember.userProfileId === state.viewerSocialProfile.profileId
                    ? updatedMember.groupRole
                    : state.group.membershipStatus
        }
    };
};

const updateGroupMemberRoleFailed = (state) => state;

const transferGroupOwnershipSuccess = (state, action) => {
    const { newGroup } = action;
    return {
        ...state,
        group: newGroup,
        groupMembers: state.groupMembers.map((member) => {
            if (member.userProfileId === newGroup.ownerId) {
                // new owner
                return {
                    ...member,
                    groupRole: GROUP_ROLE.OWNER
                };
            } else if (member.userProfileId === state.viewerSocialProfile.profileId) {
                // viewer
                return {
                    ...member,
                    groupRole: GROUP_ROLE.ADMIN
                };
            }
            return member;
        })
    };
};

const transferGroupOwnershipFailed = (state) => state;

const fetchGroupChallengesStart = (state) => ({
    ...state,
    challenges: {
        ...state.challenges,
        fetching: true,
        fetchSuccess: false,
        fetchError: false,
        nonCompleted: [],
        userJoined: []
    }
});

const fetchGroupChallengesSuccess = (state, action) => {
    const { nonCompleted, userJoined } = action;
    return {
        ...state,
        challenges: {
            ...state.challenges,
            fetching: false,
            fetchSuccess: true,
            fetchError: false,
            nonCompleted,
            userJoined
        }
    };
};

const fetchGroupChallengesFailed = (state) => ({
    ...state,
    challenges: {
        ...state.challenges,
        fetching: false,
        fetchSuccess: false,
        fetchError: true
    }
});

const updateGroupChallengeStart = (state) => ({
    ...state,
    challenges: {
        ...state.challenges,
        updateSuccess: false,
        updateError: false,
        deleteSuccess: false,
        deleteError: false
    }
});
const updateGroupChallengeSuccess = (state, { newChallenge }) => ({
    ...state,
    challenges: {
        ...state.challenges,
        nonCompleted: state.challenges.nonCompleted.map((challenge) => {
            if (challenge.uuid === newChallenge.uuid) {
                return newChallenge;
            }
            return challenge;
        }),
        updateSuccess: true,
        updateError: false
    }
});
const updateGroupChallengeFailed = (state) => ({
    ...state,
    challenges: {
        ...state.challenges,
        updateSuccess: false,
        updateError: true
    }
});

const deleteGroupChallengeStart = (state) => ({
    ...state,
    challenges: {
        ...state.challenges,
        updateSuccess: false,
        updateError: false,
        deleteSuccess: false,
        deleteError: false
    }
});
const deleteGroupChallengeSuccess = (state, { uuid }) => ({
    ...state,
    challenges: {
        ...state.challenges,
        nonCompleted: state.challenges.nonCompleted.filter((challenge) => challenge.uuid !== uuid),
        prevUuid: null,
        currentUuid: null,
        nextUuid: null,
        deleteSuccess: true,
        deleteError: false
    }
});
const deleteGroupChallengeFailed = (state) => ({
    ...state,
    challenges: {
        ...state.challenges,
        deleteSuccess: false,
        deleteError: true
    }
});

const updateGroupChallengeUuid = (state, { uuid }) => {
    // no such uuid, for example, the challenge has been removed
    if (
        !state.challenges.nonCompleted.some((challenge) => challenge.uuid === uuid) &&
        !state.challenges.userJoined.some((challenge) => challenge.uuid === uuid)
    ) {
        return state;
    }

    let prev = null,
        next = null,
        index,
        challenges;
    index = state.challenges.nonCompleted.findIndex((challenge) => challenge.uuid === uuid);
    if (index !== -1) {
        challenges = [...state.challenges.nonCompleted];
    } else {
        index = state.challenges.userJoined.findIndex((challenge) => challenge.uuid === uuid);
        challenges = [...state.challenges.userJoined];
    }

    if (index > 0) {
        prev = challenges[index - 1].uuid;
    }
    if (index !== challenges.length - 1) {
        next = challenges[index + 1].uuid;
    }

    return {
        ...state,
        challenges: {
            ...state.challenges,
            prevUuid: prev,
            currentUuid: uuid,
            nextUuid: next,
            view: challengeViewType.detail,
            updateSuccess: false,
            updateError: false,
            deleteSuccess: false,
            deleteError: false
        }
    };
};

const updateGroupChallengeView = (state, { view }) => ({
    ...state,
    challenges: {
        ...state.challenges,
        view
    }
});

const fetchGroupChallengeLeaderboardStart = (state) => ({
    ...state,
    challenges: {
        ...state.challenges,
        leaderboardFetching: true,
        leaderboardFetchSuccess: false,
        leaderboardFetchError: false
    }
});
const fetchGroupChallengeLeaderboardSuccess = (state, { data }) => ({
    ...state,
    challenges: {
        ...state.challenges,
        leaderboard: data,
        leaderboardFetching: false,
        leaderboardFetchSuccess: true,
        leaderboardFetchError: false
    }
});
const fetchGroupChallengeLeaderboardFailed = (state) => ({
    ...state,
    challenges: {
        ...state.challenges,
        leaderboardFetching: false,
        leaderboardFetchSuccess: false,
        leaderboardFetchError: true
    }
});

const resetGroupShowErrorAlert = (state) => ({
    ...state,
    showGeneralErrorAlert: false
});

const updateGroupPageShowErrorAlert = (state, { showAlert }) => ({
    ...state,
    showGroupPageErrorAlert: showAlert
});

const resetGroupFeedAnimateState = (state) => ({
    ...state,
    allFeeds: {
        ...state.allFeeds,
        list: state.allFeeds.list.map((feed) => ({
            ...feed,
            data: {
                ...feed.data,
                shouldAnimateUp: false
            }
        }))
    },
    groupPosts: {
        ...state.groupPosts,
        list: state.groupPosts.list.map((post) => ({
            ...post,
            shouldAnimateUp: false
        }))
    }
});

const uploadPostImageStart = (state, { file, imageB64, index, isRetry }) => ({
    ...state,
    groupPostImages: isRetry
        ? state.groupPostImages.map((image) => {
              if (image.index === index) {
                  return {
                      ...image,
                      uploading: true,
                      success: false,
                      error: false
                  };
              }
              return image;
          })
        : state.groupPostImages.concat({
              index,
              file,
              fileName: file.name,
              imageB64,
              uploading: true,
              success: false,
              error: false
          }),
    groupPostImageEditMode: true,
    groupPostImageUploading: true,
    groupPostImageLastIndex: isRetry ? state.groupPostImageLastIndex : index
});

const uploadPostImageSuccess = (state, { index, postImage }) => {
    const groupPostImages = state.groupPostImages.map((image) => {
        if (image.index === index) {
            return {
                ...image,
                uploading: false,
                success: true,
                error: false,
                postImage
            };
        }
        return image;
    });

    const groupPostImageUploading = groupPostImages.some((image) => image.uploading);
    const groupPostHasFailedImage = groupPostImages.some((image) => image.error);

    return {
        ...state,
        groupPostImages,
        groupPostImageUploading,
        groupPostHasValidImage: true,
        groupPostHasFailedImage
    };
};

const uploadPostImageFailed = (state, { index }) => {
    const groupPostImages = state.groupPostImages.map((image) => {
        if (image.index === index) {
            return {
                ...image,
                uploading: false,
                success: false,
                error: true
            };
        }
        return image;
    });

    const groupPostImageUploading = groupPostImages.some((image) => image.uploading);

    return {
        ...state,
        groupPostImages,
        groupPostImageUploading,
        showImageUploadRetryHint: true,
        groupPostHasFailedImage: true
    };
};

const removePostImage = (state, { index }) => {
    const groupPostImages = state.groupPostImages.filter((image) => image.index !== index);
    const groupPostImageUploading = groupPostImages.some((image) => image.uploading);
    const groupPostHasValidImage = groupPostImages.some((image) => !!image.postImage);

    return {
        ...state,
        groupPostImages,
        groupPostImageUploading,
        groupPostHasValidImage
    };
};

const removePostImages = (state) => ({
    ...state,
    groupPostImages: [],
    groupPostImageEditMode: false,
    groupPostImageUploading: false,
    groupPostHasValidImage: false,
    groupPostHasFailedImage: false,
    groupPostImageLastIndex: null
});

const updatePostImages = (state, { images }) => ({
    ...state,
    groupPostImages: images
});

const updatePostImagesLimitError = (state, { error }) => ({
    ...state,
    showPhotoLimitError: error
});

const resetPostImagesUploadRetryHint = (state) => ({
    ...state,
    showImageUploadRetryHint: false
});

const resetGroupPostError = (state) => ({
    ...state,
    postingGroupPostError: false
});

const resetGroupAnnouncementError = (state) => ({
    ...state,
    postingGroupAnnouncementError: false
});

const initializeGroupSinglePageSuccess = (state, { group, viewerSocialProfile, focusCommentUuid }) => ({
    ...state,
    group,
    viewerSocialProfile,
    focusCommentUuid,
    initializeSinglePageDone: true
});

const initializeGroupSinglePageFailed = (state) => ({
    ...state,
    initializeSinglePageError: true,
    initializeSinglePageDone: true
});

const resetGroupCommentFocus = (state) => ({
    ...state,
    focusCommentUuid: null
});

const removeImageFromGroupActivityFeed = (state, action) => {
    const { activityId, imageUuid } = action;

    let newActivityFeedList = state.activityFeed.list || [];
    let newAllFeedsList = state.allFeeds.list || [];

    const feedIndex = newActivityFeedList.findIndex((item) => item.activityId === activityId);
    const allFeedIndex = newAllFeedsList.findIndex((item) => item.data.activityId === activityId);

    if (feedIndex < 0 && allFeedIndex < 0) {
        /** nothing to change */
        return state;
    }

    if (feedIndex >= 0 && newActivityFeedList[feedIndex].activityImages) {
        const newActivityFeed = {
            ...newActivityFeedList[feedIndex]
        };
        const newActivityImages = newActivityFeed.activityImages.filter((item) => item.imageId !== imageUuid);
        newActivityFeedList = newActivityFeedList.slice(); /** make a copy */
        newActivityFeed.activityImages = newActivityImages;
        newActivityFeedList.splice(feedIndex, 1, newActivityFeed);
    }

    if (allFeedIndex >= 0 && newAllFeedsList[allFeedIndex].data.activityImages) {
        const newAllFeed = {
            ...newAllFeedsList[allFeedIndex]
        };
        const newActivityImages = newAllFeed.data.activityImages.filter((item) => item.imageId !== imageUuid);
        newAllFeedsList = newAllFeedsList.slice(); /** make a copy */
        newAllFeed.data.activityImages = newActivityImages;
        newAllFeedsList.splice(allFeedIndex, 1, newAllFeed);
    }

    return {
        ...state,
        activityFeed: {
            ...state.activityFeed,
            list: newActivityFeedList
        },
        allFeeds: {
            ...state.allFeeds,
            list: newAllFeedsList
        }
    };
};

const removeImageFromGroupPostStart = (state, action) => {
    const { postUuid, imageUuid } = action;
    let newGroupPostsList = state.groupPosts.list || [];
    let newAllFeedsList = state.allFeeds.list || [];

    const postIndex = newGroupPostsList.findIndex((item) => item.uuid === postUuid);
    const allFeedPostIndex = newAllFeedsList.findIndex((item) => item.data.uuid === postUuid);

    if (postIndex < 0 && allFeedPostIndex < 0) {
        /** nothing to change */
        return state;
    }

    if (postIndex >= 0 && newGroupPostsList[postIndex].postImages) {
        const newGroupPost = {
            ...newGroupPostsList[postIndex]
        };
        const newPostImages = newGroupPost.postImages.filter((item) => item.imageUuid !== imageUuid);
        newGroupPostsList = newGroupPostsList.slice(); /** make a copy */
        newGroupPost.postImages = newPostImages;
        newGroupPostsList.splice(postIndex, 1, newGroupPost);
    }

    if (allFeedPostIndex >= 0 && newAllFeedsList[allFeedPostIndex].data.postImages) {
        const newAllFeedPost = {
            ...newAllFeedsList[allFeedPostIndex]
        };
        const newAllFeedPostImages = newAllFeedPost.data.postImages.filter((item) => item.imageUuid !== imageUuid);
        newAllFeedsList = newAllFeedsList.slice(); /** make a copy */
        newAllFeedPost.data.postImages = newAllFeedPostImages;
        newAllFeedsList.splice(allFeedPostIndex, 1, newAllFeedPost);
    }

    return {
        ...state,
        groupPosts: {
            ...state.groupPosts,
            list: newGroupPostsList
        },
        allFeeds: {
            ...state.allFeeds,
            list: newAllFeedsList
        }
    };
};

const removeGroupProfileImage = (state) => {
    return {
        ...state,
        group: {
            ...state.group,
            profileImageUrlLarge: null,
            profileImageUrlMedium: null,
            profileImageUrlSmall: null,
            defaultImageName: null
        }
    };
};

const updateGroupSetting = (state, { group }) => ({
    ...state,
    group,
    tab: TAB_IDS.FEED, // also switch to feed tab after update
    allFeeds: INITIAL_STATE.allFeeds,
    activityFeed: INITIAL_STATE.activityFeed,
    groupPosts: INITIAL_STATE.groupPosts,
    showChangesSaved: true
});

const resetShowChangesSaved = (state) => ({
    ...state,
    showChangesSaved: false
});

const deletePostImageSuccess = (state, { newsPostUuid, newsPostHasImageId, deletePost }) => {
    if (deletePost) {
        return state;
    }

    // Remove the image from Posts and AllFeeds
    const newGroupPostsList = (state.groupPosts.list || []).map((post) => {
        if (post.uuid === newsPostUuid) {
            post.postImages = post.postImages.filter((image) => image.newsPostHasImageId !== newsPostHasImageId);
        }
        return post;
    });

    const newAllFeedsList = (state.allFeeds.list || []).map((feed) => {
        if (feed.data.uuid === newsPostUuid) {
            feed.data.postImages = feed.data.postImages.filter(
                (image) => image.newsPostHasImageId !== newsPostHasImageId
            );
        }
        return feed;
    });

    return {
        ...state,
        groupPosts: {
            ...state.groupPosts,
            list: newGroupPostsList
        },
        allFeeds: {
            ...state.allFeeds,
            list: newAllFeedsList
        }
    };
};

const deletePostImageFailed = (state) => ({
    ...state,
    showGeneralErrorAlert: true
});

const resetGroupPage = () => {
    return INITIAL_STATE;
};

const handlers = {
    [FETCH_GROUP]: fetchGroup,
    [FETCH_GROUP_SUCCESS]: fetchGroupSuccess,
    [FETCH_GROUP_FAIL]: fetchGroupFail,
    [SET_GROUP_PAGE_TAB]: setGroupPageTab,
    [SET_GROUP_PAGE_FEED_TAB_START]: setGroupPageFeedTabStart,
    [RESET_GROUP_PAGE]: resetGroupPage,
    [SAVE_GROUP_ANNOUNCEMENT]: saveGroupAnnouncement,
    [SAVE_GROUP_ANNOUNCEMENT_SUCCESS]: saveGroupAnnouncementSuccess,
    [SAVE_GROUP_ANNOUNCEMENT_FAILED]: saveGroupAnnouncementFailed,
    [DELETE_GROUP_ANNOUNCEMENT_SUCCESS]: deleteGroupAnnouncementSuccess,
    [DELETE_GROUP_ANNOUNCEMENT_FAILED]: deleteGroupAnnouncementFailed,
    [OPEN_DELETE_CONFIRM_DIALOG]: openDeleteConfirmDialog,
    [CLOSE_DELETE_CONFIRM_DIALOG]: closeDeleteConfirmDialog,
    [SAVE_GROUP_POST]: saveGroupPost,
    [SAVE_GROUP_POST_SUCCESS]: saveGroupPostSuccess,
    [SAVE_GROUP_POST_FAILED]: saveGroupPostFailed,
    [DELETE_GROUP_POST]: deleteGroupPost,
    [DELETE_GROUP_POST_SUCCESS]: deleteGroupPostSuccess,
    [DELETE_GROUP_POST_FAILED]: deleteGroupPostFailed,
    [FETCH_GROUP_POSTS]: fetchGroupPosts,
    [FETCH_GROUP_POSTS_SUCCESS]: fetchGroupPostsSuccess,
    [FETCH_GROUP_POSTS_FAILED]: fetchGroupPostsFailed,
    [FETCH_GROUP_POST_START]: fetchGroupPostStart,
    [FETCH_GROUP_POST_SUCCESS]: fetchGroupPostSuccess,
    [FETCH_GROUP_POST_FAILED]: fetchGroupPostFailed,
    [FETCH_GROUP_COMMENTS]: fetchGroupComments,
    [FETCH_GROUP_COMMENTS_SUCCESS]: fetchGroupCommentsSuccess,
    [FETCH_GROUP_COMMENTS_FAILED]: fetchGroupCommentsFailed,
    [SAVE_GROUP_COMMENT]: saveGroupComment,
    [SAVE_GROUP_COMMENT_SUCCESS]: saveGroupCommentSuccess,
    [SAVE_GROUP_COMMENT_FAILED]: saveGroupCommentFailed,
    [EDIT_GROUP_COMMENT_START]: editGroupCommentStart,
    [EDIT_GROUP_COMMENT_SUCCESS]: editGroupCommentSuccess,
    [EDIT_GROUP_COMMENT_FAILED]: editGroupCommentFailed,
    [DELETE_GROUP_COMMENT]: deleteGroupComment,
    [DELETE_GROUP_COMMENT_SUCCESS]: deleteGroupCommentSuccess,
    [DELETE_GROUP_COMMENT_FAILED]: deleteGroupCommentFailed,
    [FETCH_GROUP_CONVERSATION_LIKERS]: fetchGroupConversationLikers,
    [FETCH_GROUP_CONVERSATION_LIKERS_DONE]: fetchGroupConversationLikersDone,
    [UPDATE_GROUP_CONVERSATION_LIKE_START]: updateGroupConversationLikeStart,
    [UPDATE_GROUP_CONVERSATION_LIKE_DONE]: updateGroupConversationLikeDone,
    [FETCH_GROUP_COMMENT_LIKERS]: fetchGroupCommentLikers,
    [FETCH_GROUP_COMMENT_LIKERS_DONE]: fetchGroupCommentLikersDone,
    [UPDATE_GROUP_COMMENT_LIKE_START]: updateGroupCommentLikeStart,
    [UPDATE_GROUP_COMMENT_LIKE_DONE]: updateGroupCommentLikeDone,
    [FETCH_GROUP_ALL_FEEDS_START]: fetchGroupAllFeedsStart,
    [FETCH_GROUP_ALL_FEEDS_SUCCESS]: fetchGroupAllFeedsSuccess,
    [FETCH_GROUP_ALL_FEEDS_FAILED]: fetchGroupAllFeedsFailed,
    [FETCH_GROUP_ACTIVITY_FEEDS]: fetchGroupActivityFeeds,
    [FETCH_GROUP_ACTIVITY_FEEDS_SUCCESS]: fetchGroupActivityFeedsSuccess,
    [FETCH_GROUP_ACTIVITY_FEEDS_FAILED]: fetchGroupActivityFeedsFailed,
    [FETCH_GROUP_ACTIVITY_FEED_START]: fetchGroupActivityFeedStart,
    [FETCH_GROUP_ACTIVITY_FEED_SUCCESS]: fetchGroupActivityFeedSuccess,
    [FETCH_GROUP_ACTIVITY_FEED_FAILED]: fetchGroupActivityFeedFailed,
    [GROUP_PAGE_JOIN_GROUP_SUCCESS]: joinGroupSuccess,
    [GROUP_PAGE_ACCEPT_INVITATION_SUCCESS]: acceptInvitationSuccess,
    [UPDATE_GROUP_MEMBER_REQUEST]: updateGroupMemberRequest,
    [UPDATE_GROUP_MEMBERS]: updateGroupMembers,
    [SORT_GROUP_MEMBERS]: sortGroupMembers,
    [UPDATE_GROUP_USER_CONNECTIONS]: updateGroupUserConnections,
    [UPDATE_GROUP_USER_CONNECTION_DONE]: updateGroupUserConnectionDone,
    [UPDATE_GROUP_INVITES]: updateGroupInvites,
    [GROUP_PAGE_CANCEL_INVITE_USER_DONE]: cancelInviteUserDone,
    [GROUP_PAGE_INVITE_USER_DONE]: inviteUserDone,
    [REMOVE_GROUP_MEMBER_SUCCESS]: removeGroupMemberSuccess,
    [REMOVE_GROUP_MEMBER_FAILED]: removeGroupMemberFailed,
    [UPDATE_GROUP_MEMBER_ROLE_SUCCESS]: updateGroupMemberRoleSuccess,
    [UPDATE_GROUP_MEMBER_ROLE_FAILED]: updateGroupMemberRoleFailed,
    [TRANSFER_GROUP_OWNERSHIP_SUCCESS]: transferGroupOwnershipSuccess,
    [TRANSFER_GROUP_OWNERSHIP_FAILED]: transferGroupOwnershipFailed,
    [FETCH_GROUP_CHALLENGES_START]: fetchGroupChallengesStart,
    [FETCH_GROUP_CHALLENGES_SUCCESS]: fetchGroupChallengesSuccess,
    [FETCH_GROUP_CHALLENGES_FAILED]: fetchGroupChallengesFailed,
    [UPDATE_GROUP_CHALLENGE_START]: updateGroupChallengeStart,
    [UPDATE_GROUP_CHALLENGE_SUCCESS]: updateGroupChallengeSuccess,
    [UPDATE_GROUP_CHALLENGE_FAILED]: updateGroupChallengeFailed,
    [DELETE_GROUP_CHALLENGE_START]: deleteGroupChallengeStart,
    [DELETE_GROUP_CHALLENGE_SUCCESS]: deleteGroupChallengeSuccess,
    [DELETE_GROUP_CHALLENGE_FAILED]: deleteGroupChallengeFailed,
    [UPDATE_GROUP_CHALLENGE_UUID]: updateGroupChallengeUuid,
    [UPDATE_GROUP_CHALLENGE_VIEW]: updateGroupChallengeView,
    [FETCH_GROUP_CHALLENGE_LEADERBOARD_START]: fetchGroupChallengeLeaderboardStart,
    [FETCH_GROUP_CHALLENGE_LEADERBOARD_SUCCESS]: fetchGroupChallengeLeaderboardSuccess,
    [FETCH_GROUP_CHALLENGE_LEADERBOARD_FAILED]: fetchGroupChallengeLeaderboardFailed,
    [RESET_GROUP_SHOW_ERROR_ALERT]: resetGroupShowErrorAlert,
    [RESET_GROUP_FEED_ANIMATE_STATE]: resetGroupFeedAnimateState,
    [UPLOAD_POST_IMAGE_START]: uploadPostImageStart,
    [UPLOAD_POST_IMAGE_SUCCESS]: uploadPostImageSuccess,
    [UPLOAD_POST_IMAGE_FAILED]: uploadPostImageFailed,
    [REMOVE_POST_IMAGE]: removePostImage,
    [REMOVE_POST_IMAGES]: removePostImages,
    [UPDATE_POST_IMAGES]: updatePostImages,
    [UPDATE_POST_IMAGES_LIMIT_ERROR]: updatePostImagesLimitError,
    [RESET_POST_IMAGES_UPLOAD_RETRY_HINT]: resetPostImagesUploadRetryHint,
    [RESET_GROUP_POST_ERROR]: resetGroupPostError,
    [RESET_GROUP_ANNOUNCEMENT_ERROR]: resetGroupAnnouncementError,
    [INITIALIZE_GROUP_SINGLE_PAGE_SUCCESS]: initializeGroupSinglePageSuccess,
    [INITIALIZE_GROUP_SINGLE_PAGE_FAILED]: initializeGroupSinglePageFailed,
    [RESET_GROUP_COMMENT_FOCUS]: resetGroupCommentFocus,
    [UPDATE_GROUP_PAGE_SHOW_ERROR_ALERT]: updateGroupPageShowErrorAlert,
    [REMOVE_IMAGE_FROM_GROUP_ACTIVITY_FEED]: removeImageFromGroupActivityFeed,
    [REMOVE_IMAGE_FROM_GROUP_POST_START]: removeImageFromGroupPostStart,
    [REMOVE_GROUP_PROFILE_IMAGE]: removeGroupProfileImage,
    [GROUP_PAGE_UPDATE_GROUP_SETTING]: updateGroupSetting,
    [GROUP_PAGE_RESET_SHOW_CHANGES_SAVED]: resetShowChangesSaved,
    [DELETE_POST_IMAGE_SUCCESS]: deletePostImageSuccess,
    [DELETE_POST_IMAGE_FAILED]: deletePostImageFailed
};

export default function groupPageReducer(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];
    if (!handler) {
        return state;
    }
    return handler(state, action);
}
